import Bottle from "./components/Bottle.js";
import Countries from "./components/Countries.js";
import Footer from "./components/footer.js";
import Slides from "./components/slides.js";
import Navbar from "./components/navbar.js";
import Hero from "./components/hero.js";
function App() {
  return (
    <>
      <Hero />
      <Bottle />
      <Navbar />
      <Countries />
      <Slides />
      <Footer />
    </>
  );
}

export default App;
